export default __webpack_public_path__ + "static/media/SideBarArrowLeftBlue.d55c85d4.svg";